import React, { createContext, useContext, useEffect, useState } from 'react';
import { BASE_URL_API } from '../References/urls';

const SearchDataContext = createContext();

export const useSearchData = () => useContext(SearchDataContext);

export const SearchDataProvider = ({ children }) => {
  const [profiles, setProfiles] = useState([]);
  const [operatingAreas, setOperatingAreas] = useState([]);
  const [loading, setLoading] = useState(true);

  const CACHE_KEY_PROFILES = 'searchProfiles';
  const CACHE_KEY_AREAS = 'searchOperatingAreas';
  const CACHE_EXPIRY = 24 * 60 * 60 * 1000; // 24 hours

  const getCachedData = (key) => {
    try {
      const cached = localStorage.getItem(key);
      if (cached) {
        const { data, timestamp } = JSON.parse(cached);
        if (Date.now() - timestamp < CACHE_EXPIRY) {
          return data;
        } else {
          localStorage.removeItem(key);
        }
      }
    } catch (error) {
      console.error('Error reading cache:', error);
    }
    return null;
  };

  const setCachedData = (key, data) => {
    try {
      const cache = { data, timestamp: Date.now() };
      localStorage.setItem(key, JSON.stringify(cache));
    } catch (error) {
      console.error('Error setting cache:', error);
    }
  };

  const fetchProfiles = async () => {
    try {
      const response = await fetch(BASE_URL_API + '/getJobCategories', {
        method: 'POST',
        body: JSON.stringify({}),
      });
      if (response.ok) {
        const res = await response.json();
        if (res.status === 'success') {
          setProfiles(res.response);
          setCachedData(CACHE_KEY_PROFILES, res.response);
        }
      }
    } catch (error) {
      console.error('Error fetching profiles:', error);
    }
  };

  const fetchOperatingAreas = async () => {
    try {
      const response = await fetch(BASE_URL_API + '/getOperatingAreas', {
        method: 'POST',
        body: JSON.stringify({}),
      });
      if (response.ok) {
        const res = await response.json();
        if (res.status === 'success') {
          setOperatingAreas(res.response);
          setCachedData(CACHE_KEY_AREAS, res.response);
        }
      }
    } catch (error) {
      console.error('Error fetching operating areas:', error);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);

      const cachedProfiles = getCachedData(CACHE_KEY_PROFILES);
      const cachedAreas = getCachedData(CACHE_KEY_AREAS);

      if (cachedProfiles) {
        setProfiles(cachedProfiles);
      } else {
        await fetchProfiles();
      }

      if (cachedAreas) {
        setOperatingAreas(cachedAreas);
      } else {
        await fetchOperatingAreas();
      }

      setLoading(false);
    };

    loadData();
  }, []);

  return (
    <SearchDataContext.Provider value={{ profiles, operatingAreas, loading }}>
      {children}
    </SearchDataContext.Provider>
  );
};